import { PageBlockType } from 'src/interfaces/PageBlock';

/** Open Graph / Facebook / LinkedIn / X large-card recommended size (1.91:1). */
export const SOCIAL_SHARE_OG_WIDTH = 1200;
export const SOCIAL_SHARE_OG_HEIGHT = 630;
export const SOCIAL_SHARE_OG_ASPECT_RATIO = SOCIAL_SHARE_OG_WIDTH / SOCIAL_SHARE_OG_HEIGHT;

export const SOCIAL_SHARE_ALLOWED_BLOCK_TYPES: PageBlockType[] = [
  'text',
  'divider',
  'logo',
  'calendar',
  'countdown',
  'competitionsList',
  'image',
  'columns',
];
